module.exports = __webpack_public_path__ + "../resources/images/drophint_2x_s-c53d3a73e8479dea7ffe98859df65f9e.png";